module.exports = __webpack_public_path__ + "img/icon-rank-1.885ad5a1.svg";